
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/promocoes/recentes",
      function () {
        return require("private-next-pages/promocoes/recentes.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/promocoes/recentes"])
      });
    }
  